import axios from 'axios';
import * as qs from 'qs';

export const saveVideoFile = async (url: string, fileName: string) => {
  const response = await axios.get(url, { responseType: 'blob' });
  if (!response) throw new Error('Network response was not ok');
  const blob = response.data;
  const link = document.createElement('a');

  const objectUrl = URL.createObjectURL(blob);

  link.href = objectUrl;
  link.download = fileName;

  link.click();

  URL.revokeObjectURL(objectUrl);
  link.remove();
};

export const downloadFile = async (
  path: string,
  params?: { [key: string]: number | string | undefined | null | boolean | string[] | number[] },
  onProgress?: (progress: number) => void
) => {
  try {
    const query = qs.stringify(
      {
        ...params
      },
      {
        arrayFormat: 'repeat',
        skipNulls: true
      }
    );
    const response = await axios.get(`${path}?${query}`, {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (onProgress) {
            onProgress(percentCompleted);
          }
        }
      }
    });
    const disposition = response.headers['content-disposition'];
    let filename = 'downloaded-file';
    if (disposition && disposition.includes('filename=')) {
      filename = disposition.split('filename=')[1].replace(/["']/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Download failed:', err);
  }
};
